<div class="play-list" [style.--home-team-color]="homeTeamColor" [style.--home-team-color-solid]="homeTeamColorSolid"
  [style.--home-team-cell-bg]="homeTeamCellBg" [style.--away-team-color]="awayTeamColor"
  [style.--away-team-color-solid]="awayTeamColorSolid" [style.--away-team-cell-bg]="awayTeamCellBg">
  <div class="toolbar mat-elevation-z1 space-between">
    <div>
      <mat-icon class="large-icon" (click)="back()"
      title="{{ 'gamePlayList.back' | transloco }}">arrow_circle_left</mat-icon>
    </div>
    <div class="qtr-bar">
      <span class="label">Quart</span>
      <mat-button-toggle-group [value]="qtrFilter()" (change)="onQtrChange($event.value)" class="qtr-toggle">
        <mat-button-toggle [value]="null">Tous</mat-button-toggle>
        @for (q of qtrEnum; track q) {
          <mat-button-toggle [value]="q">
            {{q}}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>
    @if (isGameInReview() || isGameCompleted()) {
      <div class="icon-xs-spacing">
        @if (isGameInReview() && showSendHudlIcon()) {
          <mat-icon class="large-icon" (click)="sendHudlDocByEmail()"
          title="{{ 'gamePlayList.csv' | transloco }}" >dvr</mat-icon>
        }
        <mat-icon class="large-icon" (click)="generateStatsPDF()"
        title="{{ 'gamePlayList.generateStats' | transloco }}" >123</mat-icon>
        @if (isGameInReview() && showSendStatsIcon()) {
          <mat-icon class="large-icon" (click)="sendStatsByEmail()"
          title="{{ 'gamePlayList.email' | transloco }}" >mail</mat-icon>
        }
        @if (isGameCompleted()) {
          <mat-icon class="large-icon" (click)="reopenGame()"
          title="{{ 'gamePlayList.reopen' | transloco }}" >lock_open</mat-icon>
        }
      </div>
    }
  </div>

<div class="table-wrap mat-elevation-z2">
  <table mat-table [dataSource]="filteredPlays()" class="table">
    <ng-container matColumnDef="gb">
      <th mat-header-cell *matHeaderCellDef [attr.colspan]="baseCols.length" class="group-base"></th>
    </ng-container>
    <ng-container matColumnDef="gh">
      <th mat-header-cell *matHeaderCellDef [attr.colspan]="homeCols.length" class="group-head home-head">
      {{homeTeam()}}</th>
    </ng-container>
    <ng-container matColumnDef="ga">
      <th mat-header-cell *matHeaderCellDef [attr.colspan]="awayCols.length" class="group-head away-head">
      {{awayTeam()}}</th>
    </ng-container>
    <ng-container matColumnDef="gx">
      <th mat-header-cell *matHeaderCellDef class="group-base"></th>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="groupRow; sticky: true" class="group-row"></tr>

    <ng-container matColumnDef="gamePlayNumber">
      <th mat-header-cell *matHeaderCellDef class="sticky-index">#</th>
      <td mat-cell *matCellDef="let row" class="sticky-index"
        [attr.data-testid]="'gamePlayNumber-' + row.gamePlayNumber">{{ row.gamePlayNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="odk">
      <th mat-header-cell *matHeaderCellDef>ODK</th>
      <td mat-cell *matCellDef="let row; let i = index" title="Double-clic pour modifier ODK"
        (dblclick)="startEdit(i, 'odk', row.odk)">

        @if (editingCell()?.row === i && editingCell()?.col === 'odk') {
          <mat-select [(ngModel)]="row.odk" [row]="row" col="odk" [previousValue]="previousValue"
            [stopEdit]="stopEdit.bind(this, row, 'odk')" [cancelEdit]="cancelEdit.bind(this)" appAutoOpenSelect>
            @for (key of odkKeys; track key) {
              <mat-option [value]="odkEnum[key]">
                {{ odkEnum[key] }}
              </mat-option>
            }
          </mat-select>
        } @else {
          {{ row.odk }}
        }

      </td>
    </ng-container>

    <ng-container matColumnDef="qtr">
      <th mat-header-cell *matHeaderCellDef>Qtr</th>
      <td mat-cell *matCellDef="let row; let i = index" title="Double-clic pour modifier Quarter"
        (dblclick)="startEdit(i, 'qtr', row.qtr)">

        @if (editingCell()?.row === i && editingCell()?.col === 'qtr') {
          <mat-select [(ngModel)]="row.qtr" [row]="row" col="qtr" [previousValue]="previousValue"
            [stopEdit]="stopEdit.bind(this, row, 'qtr')" [cancelEdit]="cancelEdit.bind(this)" appAutoOpenSelect>
            @for (qtr of qtrEnum; track qtr) {
              <mat-option [value]="qtr">
                {{ qtr }}
              </mat-option>
            }
          </mat-select>
        } @else {
          {{ row.qtr }}
        }

      </td>
    </ng-container>

    <ng-container matColumnDef="dnDist">
      <th mat-header-cell *matHeaderCellDef>Dn/Dist</th>
      <td mat-cell *matCellDef="let row; let i = index" title="Double-clic pour modifier Down/Distance"
        (dblclick)="startEdit(i, 'dnDist', { down: row.down, distance: row.distance })">

        @if (editingCell()?.row === i && editingCell()?.col === 'dnDist') {
          <div class="dn-dist-edit" appDnDistEdit [row]="row" [previousValue]="previousValue"
            [stopEdit]="stopEdit.bind(this, row, 'dnDist')" [cancelEdit]="cancelEdit.bind(this)">
            <mat-select [(ngModel)]="row.down">
              @for (d of [1,2,3,4]; track d) {
                <mat-option [value]="d">
                  {{ d }}
                </mat-option>
              }
            </mat-select>
            <input matInput type="number" [(ngModel)]="row.distance" />
          </div>
        } @else {
          {{ row.down }} & {{ row.distance ?? 0 }}
        }

      </td>
    </ng-container>

    <ng-container matColumnDef="yardLine">
      <th mat-header-cell *matHeaderCellDef>YL</th>
      <td mat-cell *matCellDef="let row; let i = index" title="Double-clic pour modifier Yard Line"
        (dblclick)="startEdit(i, 'yardLine', row.yardLine)" [attr.data-testid]="'yardLine-' + row.gamePlayNumber">

        @if (editingCell()?.row === i && editingCell()?.col === 'yardLine') {
          <input matInput type="text" [(ngModel)]="row.yardLine" [row]="row" col="yardLine"
            [previousValue]="previousValue" [stopEdit]="stopEdit.bind(this, row, 'yardLine')"
            [cancelEdit]="cancelEdit.bind(this)" appAutoFocusInput />
          } @else {
            {{ row.yardLine }}
          }

        </td>
      </ng-container>

      <ng-container matColumnDef="hash">
        <th mat-header-cell *matHeaderCellDef>Hash</th>
        <td mat-cell *matCellDef="let row; let i = index" title="Double-clic pour modifier Hash"
          (dblclick)="startEdit(i, 'hash', row.hash)">

          @if (editingCell()?.row === i && editingCell()?.col === 'hash') {
            <mat-select [(ngModel)]="row.hash" [row]="row" col="hash" [previousValue]="previousValue"
              [stopEdit]="stopEdit.bind(this, row, 'hash')" [cancelEdit]="cancelEdit.bind(this)" appAutoOpenSelect>
              @for (key of hashKeys; track key) {
                <mat-option [value]="hashEnum[key]">
                  {{ hashEnum[key] }}
                </mat-option>
              }
            </mat-select>
          } @else {
            {{ row.hash }}
          }

        </td>
      </ng-container>

      <ng-container matColumnDef="playType">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let row; let i = index" (dblclick)="startEdit(i, 'playType', row.playType)"
          [attr.data-testid]="'playType-' + row.gamePlayNumber">

          @if (editingCell()?.row === i && editingCell()?.col === 'playType') {
            <mat-select [(ngModel)]="row.playType" [row]="row" col="playType" [previousValue]="previousValue"
              [stopEdit]="stopEdit.bind(this, row, 'playType')" [cancelEdit]="cancelEdit.bind(this)" appAutoOpenSelect>
              @for (option of (playTypeEnum | filterOptions:row:'playType'); track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
              }
            </mat-select>
          } @else {
            {{ row.playType }}
          }

        </td>
      </ng-container>

      <ng-container matColumnDef="result">
        <th mat-header-cell *matHeaderCellDef>Result</th>
        <td mat-cell *matCellDef="let row; let i = index" (dblclick)="startEdit(i, 'result', row.result)"
          [attr.data-testid]="'result-' + row.gamePlayNumber">

          @if (editingCell()?.row === i && editingCell()?.col === 'result') {
            <mat-select [(ngModel)]="row.result" [row]="row" col="result" [previousValue]="previousValue"
              [stopEdit]="stopEdit.bind(this, row, 'result')" [cancelEdit]="cancelEdit.bind(this)" appAutoOpenSelect>
              @for (option of (playResultEnum | filterOptions:row:'playResult'); track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
              }
            </mat-select>
          } @else {
            {{ row.result }}
          }

        </td>
      </ng-container>

      <ng-container matColumnDef="gnLs">
        <th mat-header-cell *matHeaderCellDef>+/−</th>
        <td mat-cell *matCellDef="let row; let i = index" title="Double-clic pour modifier Gain/Loss"
          (dblclick)="startEdit(i, 'gnLs', row.gnLs)">
          @if (editingCell()?.row === i && editingCell()?.col === 'gnLs') {
            <input matInput type="number" [(ngModel)]="row.gnLs" [row]="row" col="gnLs" [previousValue]="previousValue"
              [stopEdit]="stopEdit.bind(this, row, 'gnLs')" [cancelEdit]="cancelEdit.bind(this)" appAutoFocusInput />
            } @else {
              {{ row.gnLs }}
            }

          </td>
        </ng-container>

        <ng-container matColumnDef="penalty">
          <th mat-header-cell *matHeaderCellDef>Pen (P-Y)</th>
          <td mat-cell *matCellDef="let row; let i = index" title="Double-clic pour modifier Penalty"
            (dblclick)="startEdit(i, 'penalty', { penTeam: row.penTeam, penYards: row.penYards })">

            @if (editingCell()?.row === i && editingCell()?.col === 'penalty') {
              <div class="penalty-edit" appPenaltyEdit [row]="row" [previousValue]="previousValue"
                [stopEdit]="stopEdit.bind(this, row, 'penalty')" [cancelEdit]="cancelEdit.bind(this)">
                <input matInput type="number" [(ngModel)]="row.penYards" placeholder="Yards" />
                <mat-select [(ngModel)]="row.penTeam" placeholder="Team">
                  <mat-option [value]="null">—</mat-option>
                  @for (key of penTeamKeys; track key) {
                    <mat-option [value]="penTeamEnum[key]">
                      {{ penTeamEnum[key] }}
                    </mat-option>
                  }
                </mat-select>
              </div>
            } @else {
              {{ row.penTeam ? row.penTeam : '—' }}
              @if (row.penYards) {
                <span> ({{ row.penYards }})</span>
              }
            }

          </td>
        </ng-container>


        <ng-container matColumnDef="kickRetYds">
          <th mat-header-cell *matHeaderCellDef>K (retY)</th>
          <td mat-cell *matCellDef="let row; let i = index" title="Double-clic pour modifier Kick/Return"
            (dblclick)="openKickReturnDialog(row)">
            @if (row.kickYards !== null || row.returnYards !== null) {
              {{ row.kickYards ?? 0 }} ({{ row.returnYards ?? 0 }})
            } @else {
            }
          </td>
        </ng-container>

        @for (c of roleColsHome; track c) {
          <ng-container [matColumnDef]="c.key">
            <th mat-header-cell *matHeaderCellDef class="home-head">{{ c.label }}</th>
            <td mat-cell *matCellDef="let row; let i = index" class="home-cell"
              [title]="'Double-clic pour modifier ' + c.label" (dblclick)="startEdit(i, c.key, $any(row)[c.role])">
              @if (editingCell()?.row === i && editingCell()?.col === c.key) {
                <input matInput type="number" [(ngModel)]="$any(row)[c.role]" [row]="row" [col]="c.role"
                  [previousValue]="previousValue" [stopEdit]="stopEdit.bind(this, row, c.role)"
                  [cancelEdit]="cancelEdit.bind(this)" appAutoFocusInput />
                } @else {
                  {{ $any(row)[c.role] ?? '' }}
                }
              </td>
            </ng-container>
          }

          @for (c of roleColsAway; track c) {
            <ng-container [matColumnDef]="c.key">
              <th mat-header-cell *matHeaderCellDef class="away-head">{{ c.label }}</th>
              <td mat-cell *matCellDef="let row; let i = index" class="away-cell"
                [title]="'Double-clic pour modifier ' + c.label" (dblclick)="startEdit(i, c.key, $any(row)[c.role])">
                @if (editingCell()?.row === i && editingCell()?.col === c.key) {
                  <input matInput type="number" [(ngModel)]="$any(row)[c.role]" [row]="row" [col]="c.role"
                    [previousValue]="previousValue" [stopEdit]="stopEdit.bind(this, row, c.role)"
                    [cancelEdit]="cancelEdit.bind(this)" appAutoFocusInput />
                  } @else {
                    {{ $any(row)[c.role] ?? '' }}
                  }
                </td>
              </ng-container>
            }

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let row" class="actions text-center">
                @if (isEditable(row)) {
                  <mat-icon class="edit-play" [attr.data-testid]="'editPlay-' + row.gamePlayNumber"
                    (click)="editPlay(row); $event.stopPropagation()">
                    edit
                  </mat-icon>
                }

                @if (isGameInReview()) {
                  <mat-icon class="add-play"
                    (click)="insertAfter(row.gamePlayNumber); $event.stopPropagation()">
                    add
                  </mat-icon>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnHeader; sticky: true" class="cols-row"></tr>
            <tr mat-row *matRowDef="let row; columns: columnHeader" class="data-row" [class.non-editable]="!isEditable(row)"
              [attr.data-testid]="'gamePlayRow-' + row.gamePlayNumber">
            </tr>
          </table>
        </div>
      </div>